export default __webpack_public_path__ + "static/media/nb-s.82c7547a.jpg";